export const setToken = (token) => {
    localStorage.setItem('otoparlat_token',token);
}

export const getToken = () => {
    return localStorage.getItem('otoparlat_token');
}

export const removeToken = () => {
    return localStorage.clear();
    // return localStorage.removeItem('otoparlat_token');
}

export const setLocalValue = (key, value) => {
    localStorage.setItem(key, value);
}

export const getLocalValue = (key) => {
    return localStorage.getItem(key);
}

export const removeLocalValue = (key) => {
    return localStorage.removeItem(key);
}
